import React from 'react';
import { useTranslation } from 'react-i18next';
import lumeDrawerScreen from '../../../assets/images/lume-drawer-screen.png';
import lumeRecordsScreen from '../../../assets/images/lume-records-screen.png';
import lumeHomeScreen from '../../../assets/images/lume-home-screen-new.png';
import { ReactComponent as SensoryIcon } from '../../../assets/icons/lume-feature-sensory.svg';
import { ReactComponent as AuraIcon } from '../../../assets/icons/lume-feature-aura.svg';
import { ReactComponent as TranscribeIcon } from '../../../assets/icons/lume-feature-transcribe.svg';
import { ReactComponent as SparkleTop } from '../../../assets/icons/lume-sparkle-top.svg';
import { ReactComponent as SparkleBottom } from '../../../assets/icons/lume-sparkle-bottom.svg';
import './ProductLumeSection.scss';

const FEATURES = [
  {
    Icon: SensoryIcon,
    titleKey: 'home.productLume.feature1Title',
    descKey: 'home.productLume.feature1Desc',
    colorClass: 'sage',
  },
  {
    Icon: AuraIcon,
    titleKey: 'home.productLume.feature2Title',
    descKey: 'home.productLume.feature2Desc',
    colorClass: 'amber',
  },
  {
    Icon: TranscribeIcon,
    titleKey: 'home.productLume.feature3Title',
    descKey: 'home.productLume.feature3Desc',
    colorClass: 'rose',
  },
];

function ProductLumeSection() {
  const { t, i18n } = useTranslation();
  const isEn = !i18n.language?.startsWith('zh');

  return (
    <section className={`product-lume ${isEn ? 'product-lume--en' : ''}`}>
      <div className="product-lume__inner">
        <div className="product-lume__showcase">
          <div className="product-lume__blur-bg" />
          <div className="product-lume__glass-card">
            <img
              src={lumeDrawerScreen}
              alt={t('home.productLume.drawerAlt')}
              className="product-lume__screen product-lume__screen--drawer"
            />
            <img
              src={lumeRecordsScreen}
              alt={t('home.productLume.recordsAlt')}
              className="product-lume__screen product-lume__screen--records"
            />
            <img
              src={lumeHomeScreen}
              alt={t('home.productLume.homeAlt')}
              className="product-lume__screen product-lume__screen--home"
            />
          </div>
        </div>

        <div className="product-lume__info">
          <div className="product-lume__sparkle">
            <SparkleTop className="product-lume__sparkle-top" />
            <SparkleBottom className="product-lume__sparkle-bottom" />
          </div>

          <span className="product-lume__badge">{t('home.productLume.badge')}</span>

          <h2 className="product-lume__title">
            <span className="product-lume__title-main">{t('home.productLume.titleMain')}</span>
            {t('home.productLume.titleSub') && (
              <>
                {' '}
                <span className="product-lume__title-sub">{t('home.productLume.titleSub')}</span>
              </>
            )}
          </h2>

          <p className="product-lume__tagline">{t('home.productLume.tagline')}</p>
          <p className="product-lume__desc">{t('home.productLume.desc')}</p>

          <div className="product-lume__features">
            {FEATURES.map((feat) => (
              <div key={feat.titleKey} className="product-lume__feature">
                <div className={`product-lume__feature-icon product-lume__feature-icon--${feat.colorClass}`}>
                  <feat.Icon />
                </div>
                <div className="product-lume__feature-text">
                  <h4 className="product-lume__feature-title">
                    {t(feat.titleKey)}
                    {feat.titleKey.includes('feature3') && t('home.productLume.feature3TitleSuffix')}
                  </h4>
                  <p className="product-lume__feature-desc">{t(feat.descKey)}</p>
                </div>
              </div>
            ))}
          </div>

          <a href="/lume" className="product-lume__cta">
            {t('home.productLume.cta')}
          </a>
        </div>
      </div>
    </section>
  );
}

export default ProductLumeSection;
